/** Small inline icons from the design. All are decorative; buttons carry their own labels. */
const base = { 'aria-hidden': true, focusable: false } as const;

export const BagIcon = () => (
  <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M5 8h14l-1.2 12H6.2z" /><path d="M9 8V6a3 3 0 0 1 6 0v2" /></svg>
);
export const CloseIcon = ({ size = 12 }: { size?: number }) => (
  <svg {...base} width={size} height={size} viewBox="0 0 12 12"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" strokeWidth="1.6" /></svg>
);
export const ChevronDown = () => (
  <svg {...base} viewBox="0 0 10 10"><path d="M1 3l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.4" /></svg>
);
export const CheckIcon = () => (
  <svg {...base} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 8.5l3 3 7-7" /></svg>
);
export const SmallCheck = () => (
  <svg {...base} viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 5.2l2 2 4-4.4" /></svg>
);
export const ZoomIcon = () => (
  <svg {...base} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="7" cy="7" r="5" /><path d="M11 11l4 4" /></svg>
);
export const LockIcon = () => (
  <svg {...base} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="7" width="10" height="7" rx="1.5" /><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" /></svg>
);
export const LogoMark = () => (
  <svg {...base} viewBox="0 0 14 22"><path d="M7 21V8M7 8c0-4 4-3 4-6 0-1.2-1-2-2-2S7 .8 7 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /><path d="M1 21h12" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>
);
